/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getAccessToken } from "@lib/shared/cookies";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig } from "axios";

export interface TrackingTimeBody {
    event:
        | "timeOnSite"
        | "formTitle"
        | "formTitleSource"
        | "hiddenFormField"
        | "trustedFormCertificate";
    eventValue: string;
    eventCategory: "meta" | "conversion";
}

export interface TrackingTimeResponse {
    success: boolean;
    data: any | null;
}

export const sendTrackingTime = async (
    data: TrackingTimeBody,
): Promise<{
    data: TrackingTimeResponse["data"] | null;
    error: Error | null;
}> => {
    // Validate required fields
    if (!data || !data.event) {
        // eslint-disable-next-line no-console
        console.error("[sendTrackingTime] Event is required");
        return {
            data: null,
            error: new Error("Event is required"),
        };
    }

    if (!data.eventValue) {
        // eslint-disable-next-line no-console
        console.error("[sendTrackingTime] EventValue is required");
        return {
            data: null,
            error: new Error("EventValue is required"),
        };
    }

    if (!data.eventCategory) {
        // eslint-disable-next-line no-console
        console.error("[sendTrackingTime] EventCategory is required");
        return {
            data: null,
            error: new Error("EventCategory is required"),
        };
    }

    const accessToken = getAccessToken();
    if (!accessToken) {
        // eslint-disable-next-line no-console
        console.error("[sendTrackingTime] Access token is not available");
        return {
            data: null,
            error: new Error("Access token is not available"),
        };
    }

    const config: AxiosRequestConfig = {
        method: "post",
        url: `/api/trackingTime`,
        data: data,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken as string}`,
        },
    };

    const { data: Response, error } = await apiHandler<TrackingTimeResponse>(
        () => HTTP.client(config),
    );

    return {
        data: Response?.data ?? null,
        error,
    };
};
